import React, { useState } from "react"
import styled from "styled-components"
import "./style.sass"
import { Container, Col, Row } from "styled-bootstrap-grid"
import {
  EcosystemIcon,
  HeaderNumber,
  HeaderMenu,
  HeaderSubMenu,
  MobileMenu,
  EcosystemMenu,
  SearchForm,
} from "./components"
import { toRem } from "../../utils/styles-function"
import Button from "../../components/ui/button"

export interface IMenuProps {
  link?: string
  text?: string | React.ReactNode
}

export interface IHeaderProps {
  logo?: string | React.ReactNode
  number?: string | React.ReactNode
  numberText?: string | React.ReactNode
}

const HeaderBlock = styled.div`
  position: fixed;
  z-index: 1001;
  background: white;
  width: 100%;
`

const HeaderStyles = styled.header`
  position: relative;
  box-sizing: border-box;
  padding-top: ${toRem(19)};
  padding-bottom: ${toRem(14)};
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e2e6ec;
  &:before {
    content: "";
    background: linear-gradient(90deg, #00d900 53.92%, #ffff00 100%);
    height: 6px;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 99;
  }
`

const MobileButtonStyle = styled.div`
  margin: 20px 5px;
  width: 100%;

  @media screen and (min-width: 576px) {
    display: none;
  }
`

const LogoBlock = styled.div`
  display: flex;
  margin-top: 2px;
  align-items: center;
  max-width: 300px;
`

const LogoStyle = styled.a`
  padding-left: ${toRem(16)};
  padding-right: ${toRem(20)};
`

export const Header: React.FC<IHeaderProps> = ({
  logo,
  number,
  numberText,
}) => {
  const [showMobile, setShowMobile] = useState<boolean>(false)
  const [showEcosystem, setShowEcosystem] = useState<boolean>(false)
  const [showSearch, setShowSearch] = useState<boolean>(false)

  // separated in order to avoid incorrect outer click
  const toggleEcosystemOn = () => setShowEcosystem(true)
  const toggleEcosystemOff = () => setShowEcosystem(false)

  const toggleMobileMenu = () => setShowMobile(prevState => !prevState)
  const toggleSearch = () => setShowSearch(prevState => !prevState)

  return (
    <HeaderBlock>
      <HeaderStyles>
        <Container>
          <Row alignItems="center">
            <Col col xl="4" lg="4" md="5" sm="6">
              <LogoBlock>
                <div className="sber-ecosystem" onClick={toggleEcosystemOn}>
                  <EcosystemIcon />
                </div>
                <LogoStyle
                  className="sber-lk-logo"
                  href="https://npfsberbanka.ru/"
                >
                  {logo}
                </LogoStyle>
                <HeaderNumber number={number} numberText="горячая линия" />
                <EcosystemMenu
                  isVisible={showEcosystem}
                  onClose={toggleEcosystemOff}
                />
              </LogoBlock>
            </Col>
            {showSearch ? (
              <Col col xl="8" lg="8" md="7" sm="6">
                <SearchForm onClose={toggleSearch} />
              </Col>
            ) : (
              <Col col xl="8" lg="8" md="7" sm="6" style={{ padding: 0 }}>
                <HeaderMenu
                  onBurgerClick={toggleMobileMenu}
                  onSearchClick={toggleSearch}
                />
              </Col>
            )}
            <Col>
              <MobileMenu isVisible={showMobile} onClose={toggleMobileMenu} />
            </Col>
            <MobileButtonStyle>
              <Col col sm="12" style={{ paddingRight: 0 }}>
                <a href="https://npo.npfsb.ru/?landing=npo&step=1&_ga=2.94584732.103920865.1603875270-884543250.1602498595">
                  <Button style={{ width: "100%" }}>Оформить договор</Button>
                </a>
              </Col>
            </MobileButtonStyle>
          </Row>
        </Container>
      </HeaderStyles>
      <HeaderSubMenu />
    </HeaderBlock>
  )
}
